import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 0,
  class: "captcha-overlay"
}
const _hoisted_3 = { class: "captcha-overlay__card" }
const _hoisted_4 = { class: "amplify-heading amplify-heading--3 captcha-overlay__title" }
const _hoisted_5 = { class: "captcha-overlay__subtitle" }
const _hoisted_6 = {
  key: 0,
  class: "captcha-overlay__spinner"
}
const _hoisted_7 = {
  ref: "captchaContainer",
  class: "captcha-overlay__widget"
}
const _hoisted_8 = {
  key: 1,
  class: "captcha-overlay__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImpersonateBar = _resolveComponent("ImpersonateBar")!
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ImpersonateBar),
    _createVNode(_component_RouterView),
    _createVNode(_Transition, { name: "captcha-overlay" }, {
      default: _withCtx(() => [
        (_ctx.showCaptchaOverlay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('captcha.title')), 1),
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('captcha.subtitle')), 1),
                (_ctx.captchaLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", _hoisted_7, null, 512), [
                  [_vShow, !_ctx.captchaLoading]
                ]),
                (_ctx.captchaFailed)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.$t('captcha.error')), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}